import axiosInstance from "@/utils/AxiosInstance";
import {RequestLogin} from "@/services/auth/entities/RequestLogin";
import {ResponseLogin} from "@/services/auth/entities/ResponseLogin";
import {AuthUser} from "@/store/modules/auth";

const BASE_API = '/auth';

const login = async (body: RequestLogin): Promise<ResponseLogin> => {
    return await axiosInstance.post(`${BASE_API}/`, body);
};

const getSession = async (): Promise<AuthUser> => {
    return await axiosInstance.get(`${BASE_API}/me`);
}

const forgotPassword = async (body: any): Promise<void> => {
    await axiosInstance.post(`${BASE_API}/forgot-password`, body);
}

const changePassword = async (body: any): Promise<void> => {
    await axiosInstance.put(`${BASE_API}/change-password`, body);
}

export default {
    login,
    getSession,
    forgotPassword,
    changePassword
};
